import { ValidationSchema } from "_core/form";
import { Config, ErrorMessages } from "_core/types";
import {
  EMAIL_REGEX,
  NAME_REGEX,
  PHONE_REGEX,
  RELAXED_PHONE_REGEX,
} from "_core/validators/regex";

export type FormValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  confirmPhone: string;
  privacyPolicy: boolean;
};

export const PersonalDetailsValidator = (
  config: Config
): ValidationSchema<{
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  confirmPhone: string;
  privacyPolicy: boolean;
  consent: boolean;
}> => ({
  firstName: ({ firstName }) => {
    if (!firstName) return ErrorMessages.ENTER_FIRST_NAME;
    if (!firstName.match(NAME_REGEX)) return ErrorMessages.ENTER_FIRST_NAME;
  },
  lastName: ({ lastName }) => {
    if (!lastName) return ErrorMessages.ENTER_LAST_NAME;
    if (!lastName.match(NAME_REGEX)) return ErrorMessages.ENTER_LAST_NAME;
  },
  email: ({ email }) => {
    if (!email) return ErrorMessages.ENTER_EMAIL;
    if (!email.match(EMAIL_REGEX)) return ErrorMessages.INVALID_EMAIL_FORMAT;
  },
  phoneNumber: ({ phoneNumber }) => {
    if (!phoneNumber) return ErrorMessages.ENTER_PHONE_NUMBER;
    if (
      (config.ENVIRONMENT === "prod" && !phoneNumber.match(PHONE_REGEX)) ||
      !phoneNumber.match(RELAXED_PHONE_REGEX)
    )
      return ErrorMessages.INVALID_PHONE_NUMBER;
  },
  confirmPhone: ({ phoneNumber, confirmPhone }) => {
    if (!confirmPhone) return ErrorMessages.CONFIRM_PHONE_NUMBER;
    if (confirmPhone !== phoneNumber)
      return ErrorMessages.PHONE_NUMBER_DOES_NOT_MATCH;
  },
  privacyPolicy: ({ privacyPolicy }) => {
    if (!privacyPolicy) return ErrorMessages.YOU_MUST_AGREE;
  },
});
